import { $t } from '@/i18n';
import { defineComponent } from '@vue/composition-api';
import useApproval from '@/pages/notification/useApproval';
import { Bell } from 'lucide-vue';
export default defineComponent({
    name: 'NotificationEntry',
    methods: {
        gotoNotification() {
            this.$router.push('/notifications/approvals');
        },
    },
    setup() {
        const { getTodoCount, todoCount } = useApproval();
        return { getTodoCount, todoCount };
    },
    created() {
        this.getTodoCount();
    },
    render() {
        return (<div class="flex items-center justify-center cursor-pointer hover:text-[#1E304A]" wj-eid={$t('k_5aa48296')} onClick={this.gotoNotification}>
        {this.todoCount > 0 ? (<t-tooltip content={$t('k_97f497d6', { arg_0: this.todoCount })}>
            <t-badge count={this.todoCount} dot style={{ lineHeight: 0 }}>
              <Bell size={16}/>
            </t-badge>
          </t-tooltip>) : (<Bell size={16}/>)}
      </div>);
    },
});
